<template>
  <AddFamilyTemplate
    :header="header"
    :is-toc-visible="false"
  >
    <template #content>
      <v-layout
        justify-center
        :pt-4="$vuetify.breakpoint.mdAndUp"
      >
        <v-flex
          xs10
          sm8
        >
          <p class="f-2 fw-600 mb-1">
            {{ $t('message.thankyou') }}
          </p>
          <p class="f-1 font-weight-medium mb-4">
            {{ $t('message.send_us_consent') }}
          </p>

          <v-layout justify-center>
            <v-flex shrink>
              <p class="mb-0">
                {{ $t('address.name') }}
              </p>
              <p class="mb-0">
                {{ $t('address.street') }}
              </p>
              <p class="mb-0">
                {{ $t('address.post') }}
              </p>
            </v-flex>
          </v-layout>

          <p class="f-1 mt-4">
            {{ $t('message.summary_text_1') }}
          </p>
        </v-flex>
      </v-layout>
    </template>
    <template #actions>
      <v-layout
        justify-center
        mt-5
        :wrap="xsOnly"
        class="text-xs-center text-sm-left"
      >
        <v-flex
          shrink
          :mr-5="!xsOnly"
          mt-3
          :xs12="xsOnly"
        >
          <a href="https://www.szlachetnapaczka.pl/">{{ $t('buttons.return_to_szp') }}</a>
        </v-flex>
        <v-flex
          shrink
          :xs12="xsOnly"
          :mt-3="xsOnly"
        >
          <v-btn
            color="sz_violet"
            @click="confirmAction"
          >
            {{ $t('menu.add_new_family') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
  </AddFamilyTemplate>
</template>

<script>
import AddFamilyTemplate from '@/components/addFamily/AddFamilyTemplate';
export default {
    name: 'FamilySummary',
    components: { AddFamilyTemplate },
    computed: {
        header () {
            return {
                title: this.$t('add_family.page_title'),
                subtitle: null,
                redirect: true
            };
        },
        xsOnly () {
            return this.$vuetify.breakpoint.xsOnly;
        },
        baseUrl () {
            return process.env.BASE_URL;
        },
        fileUrl () {
            return 'dokumenty/2020_dyplom_podziekowania_dla_osob_zglaszajacych_rodziny.pdf';
        },
        pdfName () {
            return 'Dyplom podziękowania dla osób zgłaszających rodziny';
        }
    },
    methods: {
        confirmAction () {
            this.$store.commit('familyData/clearFormData');
            this.$store.commit('familyData/setConsentPageVisible', true);
            this.$router.push({ name: 'family-consent-external' });
        }
    }
};
</script>

<style scoped></style>
